import React from 'react';

import * as styles from '../icons.css';

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={60}
    viewBox="0 0 60 92"
    xmlSpace="preserve"
    focusable="false"
    fill="currentColor"
    className={styles.root}
  >
    <path
      className={styles.stroke}
      fill="none"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M1.639 5.452h56.722v69.142H1.639z"
    />
    <ellipse className={styles.shadow} cx={30.76} cy={88.422} rx={17} ry={3} />
    <path
      className={[styles.stroke, styles.fill].join(' ')}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M8.62 5.831v6.498s.038 1.474 1.619 1.474c1.582 0 1.568-1.482 1.568-1.482V3.989s-.299-2.411-2.969-2.411-2.872 2.374-2.872 2.374v8.707s.012 4.342 4.273 4.342c4.199 0 4.199-4.369 4.199-4.369V5.821"
    />
    <path
      className={[styles.stroke, styles.fill].join(' ')}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M1.639 21.979h56.722v7.895H1.639zm0 17.13h56.722v7.895H1.639zm0 16.475h56.722v7.895H1.639z"
    />
  </svg>
);
